import Button from './Button'

const ButtonBuy = ({ handler, disabled }) => {
  return <Button title="Придбати" className="btn_buy" handler={handler} disabled={disabled} />
}

export default ButtonBuy
